<template>
  <div class="col-12">
    <LoadingSpinner :loading="isPageLoading" />
    <b-tabs v-show="!isPageLoading">
      <b-tab active>
        <template v-slot:title
          >{{ $lang.azmoonLang.create_question }}
        </template>
        <b-form-group
          v-if="mode_question == `add`"
          :label="$lang.azmoonLang.question_kind"
        >
          <b-form-radio-group
            id="radioGroup"
            v-model="question_kind_selected"
            :options="question_kind"
            name="radioGroup"
          >
          </b-form-radio-group>
        </b-form-group>

        <div class="number_question" v-if="id">
          {{ $lang.azmoonLang.question_kind }}: {{ question_kind_caption }} |
          {{ $lang.azmoonLang.id_question }}:{{ id }}
        </div>
        <div v-show="question_kind_selected">
          <QuestionTitle
            ref="questionTitle"
            :question_kind="question_kind_selected"
            :allowPaginate="true"
            @selectedTitleText="selectedTitleText"
            @getTitleID="getTitleID"
          />
        </div>
        <br />
        <QuestionOptions
          ref="questionOptions"
          :title="
            question_kind_selected == 1 || question_kind_selected == 4
              ? $lang.azmoonLang.question_options
              : $lang.azmoonLang.question_description_number
          "
          v-show="includes(question_kind_selected, [1, 2, 4])"
          :allowPaginate="true"
          :question_kind="question_kind_selected"
          @sendanswerQuestion="sendAnswerQuestion"
          @arrayOptions="getArrayOptions"
        />
        <br />
        <QuestionProperty
          v-show="question_kind_selected"
          :id="id"
          :data="questionPropertyData"
          ref="questionProperty"
          :parentPermissions="['admin', 'edit']"
          @selectedQuestionRefrence="selectedQuestionRefrence"
          @changeRefrenceNumber="changeRefrenceNumber"
        />
        <br />

        <QuestionPreview
          :id="id"
          ref="questionPreview"
          :options="showKindOptions"
          :title="$lang.azmoonLang.question_preview"
          :question_title="titleText"
          :question_kind="question_kind_selected"
          @changeDisplayStyle="getDisplayStyle"
          @changeOptionShowKind="getOptionShowKind"
          @changeColNumber="changeColNumber"
          @changeDisplayMode="changeDisplayMode"
        />
        <br />
        <div v-if="question_kind_selected" class="text-right mt-2">
          <b-button
            type="button"
            class="mr-2"
            variant="outline-danger"
            @click="handleBack"
          >
            <mdicon name="close" size="20" />
            {{ $lang.azmoonLang.cancelButton }}
          </b-button>
          <b-button
            v-if="isAdmin(permissions)"
            variant="success"
            @click="checkExistOption"
            :disabled="isLoading"
          >
            <div v-show="!isLoading">
              <mdicon name="check" size="20" />
              {{ $lang.azmoonLang.submitButton }}
            </div>
            <div v-show="isLoading">
              <b-spinner small></b-spinner>
              {{ $lang.azmoonLang.textLoding }}
            </div>
          </b-button>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import QuestionTitle from "@/components/azmoon/title/questionTitle";
import QuestionOptions from "@/components/azmoon/option/questionOptions";
import QuestionProperty from "./../question_property/questionProperty";
import QuestionPreview from "./../preview/questionPreview";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr, includes } from "ramda";
import { isAdmin, renderEumOptions } from "@/shared/utils";

export default {
  components: {
    QuestionTitle,
    QuestionOptions,
    QuestionProperty,
    QuestionPreview,
    LoadingSpinner,
  },
  inject: ["questionRepository"],
  data() {
    return {
      id: this.$route.params.id,
      isLoading: false,
      isPageLoading: false,
      // question_kind: [],
      question_kind_selected: 0,
      question_kind_caption: "",
      answerQuestion: "",
      showKindOptions: [],
      arrayOptions: [],
      titleText: null,
      optionObject: {},
      showPermissionButton: true,
      option_question_refrence: {},
      question_refrence_number: null,
      display_style_id: null,
      option_show_kind: null,
      mode_question: "add",
      col_number: 1,
      display_mode: {},
      permissions: ["admin"],
      questionPropertyData: null,
    };
  },
  computed: {
    question_kind() {
      return renderEumOptions("question_kind");
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    changeDisplayMode(item) {
      this.display_mode = item;
    },
    changeRefrenceNumber(item) {
      this.question_refrence_number = item;
    },
    handleBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    getTitleID(item) {
      this.titleObject = item;
    },
    getArrayOptions(items) {
      this.arrayOptions = items;
      this.KindOptions();
    },
    getDisplayStyle(item) {
      this.display_style_id = item;
    },
    getOptionShowKind(item) {
      this.option_show_kind = item;
    },
    KindOptions() {
      this.showKindOptions = this.arrayOptions.map((x) => {
        return {
          text: x.option_description,
          value: x.option_description,
          answer: false,
          ...x,
        };
      });
    },
    selectedQuestionRefrence(item) {
      this.option_question_refrence = item;
    },
    selectedTitleText(title) {
      this.titleText = title;
    },
    sendAnswerQuestion(item) {
      this.answerQuestion = item;
    },
    checkExistOption() {
      if (
        this.question_kind_selected == 1 ||
        this.question_kind_selected == 4
      ) {
        if (this.arrayOptions.length > 1) {
          let option_answer = this.arrayOptions.filter(
            (x) => x.option_description == ""
          );

          if (option_answer.length == 0) this.save();
          else this.$notify.error(this.$lang.azmoonLang.error_option_empty);
        } else {
          this.$notify.error(
            this.$lang.azmoonLang.error_message_create_question
          );
        }
      } else {
        this.save();
      }
    },
    async save(allowAddAttachmentCode = true) {
      this.isLoading = true;
      const payload = {};
      if (this.titleObject) {
        payload.title_id = pathOr(null, ["id"], this.titleObject);
      }
      payload.title_description = this.titleText;

      if (this.question_kind_selected == 1 && this.arrayOptions.length) {
        const options = this.arrayOptions.map((val, i) => {
          return {
            ...val,
            id: val.id >= 1 ? val.id : null,
            order: i + 1,
            value: +val.value,
            number: i + 1,
          };
        });
        payload.question_kind_id = this.question_kind_selected;
        payload.options = options.map((item) => {
          delete item.option_group;
          if (!item.id) {
            delete item.id;
          }
          return item;
        });

        payload.properties =
          this.option_question_refrence && this.option_question_refrence.value;
        payload.question_refrence_id =
          this.option_question_refrence && this.option_question_refrence.value;
        payload.display_style_id =
          this.display_style_id && this.display_style_id.value;
        payload.option_show_kind_id =
          this.option_show_kind && this.option_show_kind.value;
        payload.display_mode_id = this.display_mode && this.display_mode.value;
        payload.display_count = this.col_number;
        payload.question_refrence_number = this.question_refrence_number;
      } else if (this.question_kind_selected == 4) {
        let options = this.arrayOptions.map((val, i) => {
          if (val.option_group) delete val.option_group;
          return {
            ...val,
            order: i + 1,
            value: +val.value,
            number: i + 1,
          };
        });
        payload.question_kind_id = this.question_kind_selected;
        payload.options = options.map((item) => {
          delete item.option_group;
          if (item.id < 1) {
            delete item.id;
          }
          return item;
        });

        payload.properties = pathOr(
          null,
          ["value"],
          this.option_question_refrence
        );
        payload.question_refrence_id = pathOr(
          null,
          ["value"],
          this.option_question_refrence
        );
        payload.display_style_id = pathOr(
          null,
          ["value"],
          this.display_style_id
        );
        payload.option_show_kind_id = pathOr(
          null,
          ["value"],
          this.option_show_kind
        );
        payload.display_mode_id = pathOr(null, ["value"], this.display_mode);
        payload.display_count = this.col_number;
        payload.question_refrence_number = this.question_refrence_number;
        if (this.titleObject) {
          payload.title_id = pathOr(null, ["id"], this.titleObject);
          payload.title_description = this.titleText;
        } else {
          payload.title_description = this.titleText;
        }
      } else {
        if (this.answerQuestion && this.question_kind_selected == 2) {
          payload.correct_answer = this.answerQuestion;
        }
        payload.question_refrence_number = this.question_refrence_number;
        payload.question_kind_id = this.question_kind_selected;
        payload.display_mode_id = 1;
        if (
          this.option_question_refrence &&
          Object.keys(this.option_question_refrence).length
        ) {
          payload.question_refrence_id = pathOr(
            null,
            ["value"],
            this.option_question_refrence
          );
        }
      }

      try {
        let response = null;
        if (this.mode_question == "edit") {
          response = await this.questionRepository.partial_edit(
            this.id,
            payload
          );
        } else {
          response = await this.questionRepository.create(payload);
        }

        if (allowAddAttachmentCode) {
          this.$notify.success(response.data.message);
          if (this.mode_question !== "edit") this.clear();
        } else {
          this.$notify.success(response.data.message);
        }
        this.$router.push({
          name: "searchQuestion",
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    clear() {
      this.$refs.questionTitle.captionQuestion = "";
      this.$refs.questionTitle.isOverlay = false;
      this.$refs.questionOptions.selectedArrayOptions = [];
      this.$refs.questionPreview.options = [];
      this.showKindOptions = [];
      this.arrayOptions = [];
      this.$refs.questionProperty.question_refrence_number = "";
      this.$refs.questionOptions.answer_number = "";
    },
    changeColNumber(item) {
      this.col_number = item.value;
    },
    async fetchData() {
      try {
        this.isPageLoading = true;
        const response = await this.$httpService.get(
          this.$config.api_url +
            this.$config.azmoon.question_id.replace("{0}", this.id)
        );
        let data = response.data.data;
        this.permissions = response.data.permissions;
        this.question_kind_selected = data.question_kind.id;
        this.question_kind_caption = data.question_kind.caption;
        if (data.title) {
          this.titleObject = data.title;
          this.$refs.questionTitle.titleObject = data.title;
          this.$refs.questionTitle.captionQuestion =
            data.title.title_description;
        }
        if (data.options && data.options.length > 0) {
          this.$refs.questionOptions.isCollapse = true;

          this.$refs.questionOptions.selectedArrayOptions = data.options;
        }
        // برای گرفتن پر کردن دیتا سمت پیش نمایش
        await this.$refs.questionPreview.status_options;
        await this.$refs.questionPreview.display_mode_options;
        this.questionPropertyData = {
          question_refrence: data.question_refrence,
          question_refrence_number: data.question_refrence_number,
        };

        if (data.display_mode) {
          this.$refs.questionPreview.display_mode_selected =
            this.$refs.questionPreview.display_mode_options.find(
              (x) => x.value == (data.display_mode && data.display_mode.id)
            );
          this.display_mode = this.$refs.questionPreview.display_mode_selected;
        }
        await this.$refs.questionPreview.getOptionShowKind();

        if (data.display_style) {
          this.$refs.questionPreview.status_selected =
            this.$refs.questionPreview.status_options.find(
              (x) => x.value == (data.display_style && data.display_style.id)
            );
          this.display_style_id = this.$refs.questionPreview.status_selected;
        }

        if (data.display_count) {
          this.col_number = data.display_count;
          this.$refs.questionPreview.col_number_selected =
            this.$refs.questionPreview.col_number_options.find(
              (x) => x.value == data.display_count
            );
        }

        if (data.option_show_kind) {
          this.$refs.questionPreview.show_kind_selected =
            this.$refs.questionPreview.option_show_kind.find(
              (x) =>
                x.value == (data.option_show_kind && data.option_show_kind.id)
            );
          this.option_show_kind = this.$refs.questionPreview.show_kind_selected;
        }

        if (pathOr(null, ["question_kind", "id"], data) === 2) {
          this.$refs.questionOptions.isCollapse = true;
          this.$refs.questionOptions.answer_number = pathOr(
            null,
            ["correct_answer"],
            data
          );
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isPageLoading = false;
      }
    },
  },
  async created() {
    if (this.id) {
      this.mode_question = "edit";
      this.fetchData();
    }
  },
};
</script>

<style>
.number_question {
  position: absolute;
  top: 20px;
  left: 20px;
}
</style>
